import { createRoot } from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router'
import '@/application/i18n/config' // Initialize i18n before rendering
import { msalInstance } from '@/application/auth/config/msalInstance'
import { getRoutes } from '@/routes'

// Start MSW service worker before rendering when running in mock-API mode.
// Activated by setting PUBLIC_MOCK_API=true (i.e. `pnpm dev:mock`).
if (import.meta.env.PUBLIC_MOCK_API === 'true') {
  const { worker } = await import('@/__mocks__/browser')
  await worker.start({ onUnhandledRequest: 'bypass' })
}

// Initialize MSAL and handle redirect
await msalInstance.initialize()
await msalInstance.handleRedirectPromise()

const routes = await getRoutes()
const domNode = document.getElementById('root')
if (domNode) {
  const router = createBrowserRouter(routes)
  const root = createRoot(domNode)
  root.render(<RouterProvider router={router} />)
}
